import { useContext } from 'react';
import Context from './Context';
export { default } from './Provider.js';
export { default as withToast } from './with.js';

export function useToast() {
    return useContext(Context);
}
